module.exports = __webpack_public_path__ + "img/galeria_stack_1.80fd5a49.webp";